import LegalLayout from '@/pages/legal/components/LegalLayout';

export default function CguCgv() {
  return (
    <LegalLayout
      eyebrow="Conditions contractuelles"
      title="Conditions générales d'utilisation et de vente"
      updatedAt="Septembre 2026"
      intro="Les présentes conditions régissent l'accès et l'utilisation de la plateforme MEDICACLIC par les patients (« Utilisateurs ») ainsi que les prestations souscrites par les professionnels de santé (« Praticiens »). Toute utilisation du site vaut acceptation pleine et entière des présentes conditions."
    >
      <h2>1. Objet et champ d'application</h2>
      <p>
        MEDICACLIC met à disposition une plateforme de mise en relation et de prise de rendez-vous
        en ligne avec les professionnels de santé de Rabat. Les présentes conditions s'appliquent à
        tous les utilisateurs du site, qu'ils soient patients ou praticiens.
      </p>

      <h2>2. Accès au service</h2>
      <p>
        La recherche et la consultation de l'annuaire sont <strong>gratuites et libres d'accès</strong>.
        Un compte minimal (nom, prénom, numéro de téléphone) est requis uniquement pour confirmer,
        retrouver, annuler ou reprogrammer un rendez-vous. L'utilisateur s'engage à fournir des
        informations exactes et à jour.
      </p>

      <h2>3. Prise de rendez-vous</h2>
      <ul>
        <li>Les créneaux affichés proviennent des agendas réels des praticiens connectés.</li>
        <li>La confirmation est envoyée par WhatsApp, avec un rappel automatique la veille.</li>
        <li>L'annulation et la reprogrammation sont libres, sans pénalité ni frais.</li>
        <li>Aucun paiement d'honoraires médicaux n'est encaissé par MEDICACLIC : le règlement de la consultation s'effectue directement auprès du praticien.</li>
      </ul>

      <h2>4. Non-commercialisation de l'acte médical</h2>
      <p>
        MEDICACLIC <strong>ne commercialise pas l'acte médical</strong>. La plateforme est un service
        de mise en relation et de prise de rendez-vous : elle ne vend, ne facture et ne rémunère
        aucun acte de soins, n'intervient ni dans la relation médicale ni dans le diagnostic, et
        n'encaisse aucun honoraire. Le règlement de la consultation s'effectue exclusivement entre
        le patient et le praticien.
      </p>
      <p>
        Cette position est conforme à la <strong>loi n° 131-13 relative à l'exercice de la médecine
        (articles 2 et 26)</strong> ainsi qu'au <strong>Code de déontologie médicale marocain</strong>,
        qui interdisent la commercialisation de l'acte médical et le partage d'honoraires y afférent.
        La rémunération de MEDICACLIC repose uniquement sur ses prestations de visibilité, d'outillage
        et d'abonnement, jamais sur l'acte de soins.
      </p>

      <h2>5. Obligations de l'utilisateur</h2>
      <p>
        L'utilisateur s'engage à ne pas perturber le fonctionnement du site, à ne pas tenter d'accéder
        de manière frauduleuse aux données, et à respecter les rendez-vous pris. Les rendez-vous
        répétés et non honorés peuvent entraîner une limitation de l'accès au service.
      </p>

      <h2>6. Obligations des praticiens</h2>
      <p>
        Le praticien garantit détenir les titres et autorisations nécessaires à l'exercice de son
        activité, la véracité des informations publiées sur sa fiche (spécialité, coordonnées,
        tarifs, diplômes) et la bonne tenue de son agenda. Il demeure seul responsable de la relation
        de soins et du respect de ses obligations déontologiques.
      </p>

      <h2>7. Formules et conditions commerciales (Professionnels)</h2>
      <p>
        L'inscription à l'annuaire crée une fiche gratuite. Les formules payantes (AF, ARS, Premium)
        et prestations SEO/GEO/AEO donnent accès à des services de visibilité et d'outils avancés.
        Le détail des contenus, des tarifs et des durées est communiqué dans le devis accepté par le
        praticien. <strong>Aucun abonnement n'est lié au nombre de patients adressés</strong> :
        la facturation est un abonnement fixe mensuel, conforme au cadre déontologique marocain.
      </p>
      <ul>
        <li>Les tarifs sont exprimés en dirhams marocains (MAD), hors taxes le cas échéant.</li>
        <li>La résiliation s'effectue selon les modalités et le préavis indiqués au devis.</li>
        <li>Les données de la fiche peuvent être exportées par le praticien avant résiliation.</li>
      </ul>

      <h2>8. Statut Partenaire</h2>
      <p>
        Le <strong>« Statut Partenaire »</strong> s'applique aux entreprises, organisations ou réseaux
        ayant conclu une <strong>convention avec des praticiens de leur choix</strong>. Ce dispositif
        fonctionne de la manière suivante :
      </p>
      <ul>
        <li>L'entreprise partenaire conventionne avec les praticiens qu'elle sélectionne au sein de la plateforme ;</li>
        <li>Un <strong>code partenaire</strong> est transmis aux bénéficiaires (salariés, adhérents, membres du réseau) ; en le saisissant lors de la recherche, ils sont orientés en priorité vers les praticiens de leur réseau partenaire ;</li>
        <li>Les bénéficiaires profitent d'un <strong>avantage dédié dans les pharmacies partenaires</strong>, sur présentation d'un QR code unique en caisse.</li>
      </ul>
      <p>
        Le Statut Partenaire a pour seul objet de faciliter l'accès aux soins au sein du réseau
        conventionné. Il ne conditionne ni la qualité ni l'accès aux soins, et n'implique aucune
        rémunération liée au nombre de patients adressés. Les praticiens partenaires adhèrent
        librement au dispositif, dans le respect du Code de déontologie médicale marocain.
      </p>

      <h2>9. Disponibilité et responsabilité</h2>
      <p>
        MEDICACLIC met en œuvre les moyens raisonnables pour assurer la disponibilité du service,
        sans garantie d'absence totale d'interruption (maintenance, incident technique, dépendance
        à des services tiers). La plateforme ne saurait être tenue responsable de l'issue d'une
        consultation ni de l'indisponibilité d'un praticien.
      </p>

      <h2>10. Données personnelles</h2>
      <p>
        Le traitement des données personnelles est décrit dans la Politique de confidentialité,
        accessible depuis le pied de page du site, et conduit conformément à la loi 09-08 relative
        à la protection des données personnelles au Maroc.
      </p>

      <h2>11. Modification et droit applicable</h2>
      <p>
        MEDICACLIC peut modifier les présentes conditions à tout moment ; la version en vigueur est
        celle publiée sur le site. Les conditions sont régies par le droit marocain et tout litige
        relève de la compétence des tribunaux de Rabat.
      </p>
    </LegalLayout>
  );
}